export default "__VITE_ASSET__3d96af1f__"